import { useState } from 'react';

interface ServiceWorkerUpdatePromptProps {
  show: boolean;
  onReload: () => void;
}

/**
 * Non-blocking toast shown when a new app version has been deployed and is waiting
 * to activate. The user chooses when to reload, so an in-progress form is never
 * blown away by an automatic refresh. Wired from App via useServiceWorker().
 */
const ServiceWorkerUpdatePrompt = ({
  show,
  onReload,
}: ServiceWorkerUpdatePromptProps) => {
  const [applying, setApplying] = useState(false);

  if (!show) {
    return null;
  }

  const handleClick = () => {
    if (applying) {
      return;
    }
    setApplying(true);
    onReload();
  };

  return (
    <div
      role='status'
      aria-live='polite'
      className='fixed inset-x-0 bottom-4 z-[9999] mx-auto flex w-fit max-w-[92vw] items-center gap-3 rounded-lg bg-gray-900 px-4 py-3 text-sm text-white shadow-lg'
    >
      <span>มีเวอร์ชันใหม่พร้อมใช้งาน</span>
      <button
        type='button'
        onClick={handleClick}
        disabled={applying}
        className='rounded-md bg-blue-600 px-3 py-1 font-medium text-white transition-colors hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 disabled:cursor-not-allowed disabled:opacity-70'
      >
        {applying ? 'กำลังโหลด…' : 'โหลดใหม่'}
      </button>
    </div>
  );
};

export default ServiceWorkerUpdatePrompt;
